import { render, staticRenderFns } from "./MyCheckSwissCriminalRecordStatus.vue?vue&type=template&id=450b0e8c&"
import script from "./MyCheckSwissCriminalRecordStatus.vue?vue&type=script&lang=js&"
export * from "./MyCheckSwissCriminalRecordStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports